<template>
  <PreviewAlertCard
    :color="theme.color"
    :icon="theme.icon"
    :title="title"
    :learn-more-href="ARCHITECTURE_ALERT_LEARN_MORE_URL"
    @learn-more-click="handleLearnMoreClick"
  >
    {{ bodyText }}
  </PreviewAlertCard>
</template>

<script setup>
import { computed } from 'vue';
import PreviewAlertCard from '@/components/shared/PreviewAlertCard.vue';
import {
  ARCHITECTURE_ALERT_LEARN_MORE_URL,
  getAlertCategoryForCode,
  getArchitectureAlertPreviewLabel,
  getArchitectureAlertPreviewTheme,
  getArchitectureAlertTooltip,
} from '@/components/jobArchitecture/alertHelpers';
import { useTracking } from '@/stores/tracking/tracking';

const props = defineProps({
  code: {
    type: String,
    required: true,
  },
  tooltipContext: {
    type: Object,
    default: () => ({ familyNames: [], groupNames: [] }),
  },
});

const theme = computed(() => getArchitectureAlertPreviewTheme(props.code));

const title = computed(() => getArchitectureAlertPreviewLabel(props.code));

const assignmentNames = computed(() => {
  const category = getAlertCategoryForCode(props.code);

  if (category === 'multiple_assignments') {
    return props.tooltipContext.familyNames ?? [];
  }

  return [];
});

const bodyText = computed(() => getArchitectureAlertTooltip({
  code: props.code,
  nodeType: 'profile',
  assignmentNames: assignmentNames.value,
}));

const handleLearnMoreClick = () => {
  useTracking().jaListExpandedAlertInfoBox();
};
</script>
